import { EnvConfig } from '@hometap/htco-components';

const env = EnvConfig();

export default env;

export const getVersion = () => {
  return process.env.REACT_APP_VERSION;
};
